import {
  AgendaEventTitle,
  CardContainer,
  ContentContainer,
  DateSquare,
  Day,
  Month,
  Times,
  TimesContainer,
  TypoSpan,
} from "./AgendaEvent.components"

export type AgendaEventProps = {
  id: number
  title: string
  day: string
  month: string
  startTime: string
  endTime: string
  link?: string
  cancelled?: boolean
}

export const AgendaEvent = ({
  link,
  title,
  day,
  month,
  startTime,
  endTime,
  cancelled,
}: AgendaEventProps) => {
  return (
    <CardContainer link={link}>
      <DateSquare>
        <Day cancelled={cancelled}>{day}</Day>
        <Month>{month}</Month>
      </DateSquare>

      <ContentContainer>
        <AgendaEventTitle cancelled={cancelled}>{title}</AgendaEventTitle>
        <TimesContainer cancelled={cancelled}>
          {!!cancelled && <TypoSpan>Annulé / </TypoSpan>}
          <Times cancelled={cancelled}>
            {startTime} - {endTime}
          </Times>
        </TimesContainer>
      </ContentContainer>
    </CardContainer>
  )
}
